import * as global from 'brokertslib/src/helpers/global'
import { yupResolver } from "@hookform/resolvers/yup"
import { Box, Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, Button, ModalFooter } from '@chakra-ui/react'
import { InsuranceParamsTravelDto } from 'BrokerTsLib/src/dtos'
import { useContext } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { insuranceParamsContext } from '../layouts/Wizard'
import { Step2FormValues, transformInsuranceParamsToStep2FormValues } from './cestovko/Step2Form'
import { ExtraInsuranceCestovko } from './ExtraInsuranceCestovko'
import { schema } from '../containers/cestovko/Step2Form'
import { useSaveStep2 } from '../hooks/useWizard'
import { useCestovkoOffersContext } from '../context/CestovkoOffersProvider'
import { AxiosError } from 'axios'
import ErrorSummary from '../components/ErrorSummary'
import { Save } from '../icons'

function ExtraInsuranceCestovkoModal({
    isOpen = false,
    onClose
}: {
    isOpen: boolean
    onClose: () => void
}) {
    const { mutateAsync: submitForm, isLoading: isSaving } = useSaveStep2()
    const { recalculateOffers: recalculate } = useCestovkoOffersContext()

    const { insuranceParams: insuranceParamsGeneric, insuranceParamsId: paramsId, refetchInsuranceParams } = useContext(insuranceParamsContext)!
    const insuranceParams = insuranceParamsGeneric as InsuranceParamsTravelDto

    const formValues = transformInsuranceParamsToStep2FormValues(insuranceParams, paramsId);

    const methods = useForm<Step2FormValues>({
        defaultValues: formValues,
        resolver: yupResolver(schema) as any,
        mode: 'onBlur'
    })

    const {
        handleSubmit,
        setError,
        reset,
        formState: { errors },
    } = methods

    const closeModal = () => {
        onClose()
    }

    const onSubmitForm = handleSubmit((data) => {
        return submitForm({ ...data, paramsId: paramsId ?? "" })
            .then((response) => {
                refetchInsuranceParams()
                    .then(() => {
                        recalculate()
                        closeModal()
                    })

            })
            .catch((err: AxiosError<any>) => {
                if (!(err.response && err.response.status === 400 && err.response.data))
                    return;

                let data = err.response.data

                // zobrazeni serverove validace
                Object.keys(data).forEach((x: any) => {
                    setError(global.toCamelCase(x), { message: data[x].join(' ') })
                })

                alert('Při ukládání došlo k chybě')
            })
            .finally(() => { })
    })

    return (
        <Modal size="6xl" onClose={onClose} isOpen={isOpen}>
            <ModalOverlay />

            <FormProvider {...methods}>
                <form onSubmit={onSubmitForm}>
                    <ModalContent>
                        <ModalHeader>Nastavení parametrů pro všechny nabídky</ModalHeader>
                        <ModalBody>
                            <Box sx={{ display: 'grid', gap: 8 }}>
                                <ExtraInsuranceCestovko showIcons={true} />
                            </Box>
                        </ModalBody>
                        <ModalFooter flexDirection='column-reverse' alignItems='flex-end'>
                            <Button colorScheme="primary" onClick={onSubmitForm} isLoading={isSaving} isDisabled={isSaving}                            >
                                <Save />
                                Uložit a přepočítat
                            </Button>

                            <ErrorSummary errors={errors} />
                        </ModalFooter>
                    </ModalContent>
                </form>
            </FormProvider>
        </Modal>
    )
}

export default ExtraInsuranceCestovkoModal



